import React from 'react';
import {
  BOWL_POSITION,
  CAPACITY_SIZE,
  CAPACITY_TO_OVERFLOW,
  CARTRIDGE_SIZE,
  CARTRIDGE_TYPE,
  CLEAN_FLUSH,
  INDEPENDENT_LIVING_COMPLAINT,
  INLET_TYPE,
  ISAMBULANT,
  ISCOMPLIANT,
  ISNZCOMPLAINT,
  ITEM_NAME,
  ITEM_TAPHOLES,
  LITRES_PER_MINUTE,
  MOUNT_TYPE,
  OUTLET_LENGTH,
  OUTLET_TYPE,
  OVERFLOW,
  PAN_HEIGHT,
  PAN_PROJECTION,
  RAIL_LENGTH,
  SHAPE,
  SHOWER_HEAD_SIZE,
  SPRAY_FUNCTIONS,
  SURFACE_FINISH,
  TAPHOLES,
  TRAP_TYPE,
  WASTE_POSITION,
  WELS_FLOWRATE_1,
  WELS_FLOWRATE_2,
} from '@/helpers/constants/attributes';

interface Props {
  attributes: Record<string, any>;
  isLandscapeMode?:any
}

const RELEVANT_KEYS = new Set([
  CAPACITY_SIZE,
  ITEM_TAPHOLES,
  TRAP_TYPE,
  INLET_TYPE,
  PAN_HEIGHT,
  PAN_PROJECTION,
  CLEAN_FLUSH,
  MOUNT_TYPE,
  OUTLET_TYPE,
  OUTLET_LENGTH,
  CARTRIDGE_SIZE,
  CARTRIDGE_TYPE,
  LITRES_PER_MINUTE,
  SHAPE,
  WASTE_POSITION,
  WELS_FLOWRATE_1,
  WELS_FLOWRATE_2,
  SPRAY_FUNCTIONS,
  RAIL_LENGTH,
  SHOWER_HEAD_SIZE,
  OVERFLOW,
  TAPHOLES,
  CAPACITY_TO_OVERFLOW,
  SURFACE_FINISH,
  BOWL_POSITION,
  ISCOMPLIANT,
  ISAMBULANT,
  INDEPENDENT_LIVING_COMPLAINT,
  ISNZCOMPLAINT,
]);

const getFormattedValue = (key: string, value: any): string => {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value !== 'string' && typeof value !== 'number') return '';

  switch (key) {
    case PAN_HEIGHT:
    case PAN_PROJECTION:
    case RAIL_LENGTH:
    case OUTLET_LENGTH:
    case SHOWER_HEAD_SIZE:
      return `${value} mm`;
    case CAPACITY_SIZE:
      return `${value} L`;
    case LITRES_PER_MINUTE:
      return `${value} L /min`;
    case WELS_FLOWRATE_1:
    case WELS_FLOWRATE_2:
      return typeof value === 'string' ? value.replace('L/min', ' L / min') : `${value}`;
    case CARTRIDGE_SIZE:
      return typeof value === 'string' ? value.replace(/(\d)([a-zA-Z])/g, '$1 $2') : `${value}`;
    default:
      return value.toString();
  }
};


const getDisplayName = (key: string): string => {
  if (key === CARTRIDGE_SIZE) return 'Cartridge Size';
  if (key === CLEAN_FLUSH) return 'Cleanflush';
  return key.replaceAll('-', ' ').replace('gwa', '');
};

const VariantAttributesList: React.FC<Props> = ({ isLandscapeMode = true, attributes }) => {
  return (
    <>
      {Object.entries(attributes)
        .reverse()
        .filter(([key, value]) =>
          RELEVANT_KEYS.has(key) &&
          value !== '' &&
          value !== 'Not Applicable' &&
          value !== 0 &&
          key !== ITEM_NAME &&
          !Array.isArray(value),
        )
        .map(([key, value], index) => (
          <div key={index} className="flex flex-col print:gap-1 h-full">
            <div className={isLandscapeMode ? 
                            'flex text-[14px] font-normal leading-6 print:text-xs lg:text-[14px] min-w-0' : 
                            'flex text-[14px] font-normal leading-6 print:gap-0.5 print:text-xs lg:gap-0 lg:text-16 h-full min-w-0'}>
              <span className="flex-1 capitalize text-[#4D4D4D] break-words min-w-0">{getDisplayName(key)}</span>
              <span className="ml-2 md:ml-[20px] flex-1 text-[#090909] print:ml-0 text-left print:text-left break-words min-w-0">
                {getFormattedValue(key, value)}
              </span>
            </div>
            {isLandscapeMode ? (
              <div className="border-b border-[#666666]" />
            ) : (
              <div className="attribute-break-h" style={{ marginBottom: '0px' }} />
            )}
          </div>
        ))}
    </>
  );
};

export default VariantAttributesList;
